import React from 'react';
import { usePanels } from './App';

const AboutPanel = () => {
  const { swapPanel } = usePanels();

  return (
    <div id="aboutPanel" className="Panel Panel-right">
      <button 
        className="btn-back left-panel-btn" 
        onClick={() => swapPanel('menu', 'leftPanel')}
      >
        ⬅ Back
      </button>
      <h2>1. Is AI really intelligent?</h2>
      <p>
        It depends on who you ask. But, at the end of the day, it is a machine - a series of zeros and ones. But those zeros and ones are constructed in so many dimensions, that it can feel like it is alive to the humans today. 
      </p>
      <p>
        Once the humanity gets used to it, it will feel like any other piece of technology. Remember, how magical it was to be able to edit a PDF?
      </p>

      <h2>2. Is AI going to take away my job/business?</h2>
      <p>
        AI won't. But someone using AI - will. Things that used to take days or weeks to complete by multiple people even three years ago, can now be done in a matter of minutes. How do you compete with that?
      </p>
      <p>
        That is why it is important to learn and adapt.
      </p>
      <h2>3. Is AI a threat to the humanity?</h2>
      <p>
        Job displacement, biased decision-making, the fear of rogue machines...? The greatest risks come not from the technology itself, but what the humans grow it to become.
      </p>
      <p>
        At Psycode, we put the humans and their habitats in the centre of every discussion. We align our projects with Australia's AI Ethics Principles. 
        Our consultancy doesn't simply hand over code; we guide you through risk assessment, stakeholder engagement and ongoing monitoring. 
        By building the right understanding from day one, your business can reap AI's benefits—confident that you are "raising a good AI".
      </p>

      <h2>4. Is AI useful for me?</h2>
      <p>
        AI can:
      </p>
      <ul>
        <li>Automate repetitive tasks, freeing your team to focus on higher-value work.</li>
        <li>Enhance customer experiences with personalised recommendations, chatbots or adaptive learning platforms.</li>
        <li>Unlock actionable insights by analysing customer behaviour, supply-chain patterns or market trends.</li>
      </ul>
      <p>
        <span onClick={() => swapPanel('contact', 'rightPanel')} style={{cursor: 'pointer', textDecoration: 'underline'}}>
          Do you see any use of these in your business? Let's talk about it.
        </span>
      </p>

      <h2>5. Is AI friendly to humans?</h2>
      <p>
        AI is and will be what you make of it. It can be your friend, your confidant, your most trusted employee or your arch-nemesis. You choose - we will guide you how to get there.
      </p>

      <h2>Ready to get started?</h2>
      <p>Let the Psycode team guide you from curiosity to confidence.</p>
      <p>
        <span onClick={() => swapPanel('contact', 'rightPanel')} style={{cursor: 'pointer', textDecoration: 'underline'}}>
          👉 Get in touch for a quick intro to see how can help you.
        </span>
      </p>
      <p>Or connect with us on LinkedIn: <span onClick={() => window.open('https://www.linkedin.com/company/psycode/', '_blank')} style={{cursor: 'pointer', textDecoration: 'underline'}}>
        https://www.linkedin.com/company/psycode/
      </span></p>
      <p style={{ display: 'none' }}>👉 Download our "AI for SMEs" quick-start guide</p>
      <br />
      <p>Together, we'll ensure your journey into AI is informed, ethical and truly transformative.</p>
    </div>
  );
};

export default AboutPanel;
